const getRowArr = (row: string): string[] | string => {
    if (row) {
        return row.replace(/"/g, "").split(",");
    }
    return "";
};

export default getRowArr;
